import { Calendar, momentLocalizer, Views } from 'react-big-calendar';
import moment from 'moment';
import { OwnBookingsBookingsData } from '../../../types/AdminTypes';
import React from 'react';
import { useCallback } from 'react';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Box } from '@chakra-ui/react';
import { CalendarBookingContainer } from './BookingBigCalendarStyled';
import { clientBookingText } from '../../../services/Admin/DashboardService';

const localizer = momentLocalizer(moment);

interface BookingBigCalendarProps {
  ownBookingsData: Array<OwnBookingsBookingsData>;
  objectSelected: OwnBookingsBookingsData;
  selectedYear: number;
  selectedMonth: number;
  handleSelectedYear: (year: number) => void;
  handleSelectedMonth: (MONTH: number) => void;
}

export const BookingBigCalendar = (props: BookingBigCalendarProps): JSX.Element => {
  const {
    ownBookingsData,
    objectSelected,
    selectedMonth,
    selectedYear,
    handleSelectedYear,
    handleSelectedMonth,
  } = props;

  const OWN_BOOKING = 'OWN_BOOKING';
  const BLOCKING = 'BLOCKING';
  const BOOKING = 'BOOKING';

  const getBigCalendarEvents = useCallback(() => {
    const bookings = objectSelected.Bookings;

    const ownBookings = bookings
      .filter(booking => booking.Type === OWN_BOOKING)
      .map(booking => {
        return {
          start: new Date(booking.arrivalDate),
          end: new Date(booking.departureDate),
          title: booking.Comment,
          resource: booking.Type,
        };
      });

    const blockedBookings = bookings
      .filter(booking => booking.Type === BLOCKING)
      .map(booking => {
        return {
          start: new Date(booking.arrivalDate),
          end: new Date(booking.departureDate),
          title: '',
          resource: booking.Type,
        };
      });

    const regularBookings = bookings
      .filter(booking => booking.Type === BOOKING)
      .map(booking => {
        return {
          start: new Date(booking.arrivalDate),
          end: new Date(booking.departureDate),
          title: clientBookingText(booking),
          resource: booking.Type,
        };
      });

    return ownBookings.concat(blockedBookings).concat(regularBookings);
  }, [ownBookingsData, objectSelected]);

  const bigCalendarEvents = getBigCalendarEvents();

  const eventStyleGetter = (event: any, start: any, end: any, isSelected: boolean) => {
    const ownBookingStyle = {
      backgroundColor: 'var(--chakra-colors-red-600)',
      color: 'white',
      minHeight: '24px',
    };

    const blockingStyle = {
      backgroundColor: '#975A16',
      color: 'none',
      border: 'none',
      minHeight: '4px',
    };

    const clientBookingStyle = {
      backgroundColor: 'var(--chakra-colors-blue-500)',
      color: 'white',
      minHeight: '24px',
    };
    if (event.resource === OWN_BOOKING) {
      return { style: ownBookingStyle };
    } else if (event.resource === BLOCKING) {
      return { style: blockingStyle };
    } else {
      return { style: clientBookingStyle };
    }
  };

  return (
    <CalendarBookingContainer>
      <Box bgColor={'white'}>
        {ownBookingsData && (
          <Calendar
            showAllEvents={true}
            toolbar={false}
            events={bigCalendarEvents}
            localizer={localizer}
            eventPropGetter={eventStyleGetter}
            date={new Date(selectedYear, selectedMonth)}
            onNavigate={date => {
              handleSelectedYear(date.getFullYear());
              handleSelectedMonth(date.getMonth());
            }}
            views={[Views.MONTH]}
            defaultView={Views.MONTH}
          />
        )}
      </Box>
    </CalendarBookingContainer>
  );
};
